// Source of Truth for Exercise and Workout Timing
// Generated from actual audio file durations
// Last updated: 2025-08-20T19:43:05.770Z

export const exerciseTiming = {
  main: {
    armCircles: 113,
    bearCrawl: 267,
    bigArmSwings: 143,
    bridgeHolds: 280,
    burpees: 273,
    crabWalk: 296,
    'diamondpush-ups': 285,
    dragonwalk: 334,
    fastFeet: 272,
    frogJumps: 273,
    highKnees: 341,
    inchwormWalk: 382,
    jumpingJacks: 245,
    jumpsquats: 477,
    'l-sithold': 262,
    miniSquats: 344,
    mountainClimbers: 365,
    mountainclimberburpees: 330,
    oneLegStand: 353,
    'pikepush-ups': 384,
    plank: 283,
    pushUps: 371,
    rabbitHops: 371,
    rainbowReaches: 366,
    shoulderTaps: 62,
    sideLunges: 450,
    'single-legdeadlifts': 697,
    'single-legsquats': 798,
    skaterHops: 446,
    splitjumps: 354,
    sprintintervals: 457,
    starJumps: 531,
    stepjumps: 514,
    supermanHolds: 570,
    thrusters: 390,
    tigerPounces: 553,
    tricepDips: 530,
    tuckjumps: 427,
    upperCuts: 607,
    wallSits: 416,
    zebraGallops: 513,
  },
  intros: {
    armCircles: 11,
    bearCrawl: 9,
    bigArmSwings: 10,
    bridgeHolds: 12,
    burpees: 17,
    crabWalk: 10,
    'diamondpush-ups': 9,
    dragonwalk: 12,
    fastFeet: 9,
    frogJumps: 11,
    highKnees: 10,
    inchwormWalk: 10,
    jumpingJacks: 6,
    jumpsquats: 16,
    'l-sithold': 8,
    miniSquats: 9,
    mountainClimbers: 13,
    mountainclimberburpees: 8,
    oneLegStand: 12,
    'pikepush-ups': 11,
    plank: 10,
    pushUps: 12,
    rabbitHops: 8,
    rainbowReaches: 14,
    shoulderTaps: 9,
    sideLunges: 10,
    'single-legdeadlifts': 9,
    'single-legsquats': 10,
    skaterHops: 11,
    splitjumps: 9,
    sprintintervals: 11,
    starJumps: 10,
    stepjumps: 9,
    supermanHolds: 12,
    thrusters: 8,
    tigerPounces: 10,
    tricepDips: 8,
    tuckjumps: 8,
    upperCuts: 8,
    wallSits: 13,
    zebraGallops: 11,
  },
};

export const workoutTiming = {
  intros: {
    1: {
      baseball: 10,
      basketball: 9,
      cricket: 9,
      dance: 9,
      football: 9,
      golf: 9,
      gymnastics: 9,
      hockey: 9,
      lacrosse: 9,
      rugby: 9,
      soccer: 9,
      swimming: 9,
      tennis: 9,
      track: 9,
      volleyball: 9,
    },
    2: {
      baseball: 10,
      basketball: 10,
      cricket: 8,
      dance: 9,
      football: 10,
      golf: 9,
      gymnastics: 10,
      hockey: 9,
      lacrosse: 9,
      rugby: 9,
      soccer: 10,
      swimming: 9,
      tennis: 9,
      track: 9,
      volleyball: 10,
    },
    3: {
      baseball: 8,
      basketball: 8,
      cricket: 7,
      dance: 7,
      football: 8,
      golf: 8,
      gymnastics: 8,
      hockey: 8,
      lacrosse: 8,
      rugby: 9,
      soccer: 8,
      swimming: 8,
      tennis: 8,
      track: 7,
      volleyball: 8,
    },
    4: {
      baseball: 8,
      basketball: 8,
      cricket: 8,
      dance: 8,
      football: 8,
      golf: 8,
      gymnastics: 8,
      hockey: 8,
      lacrosse: 8,
      rugby: 8,
      soccer: 8,
      swimming: 7,
      tennis: 8,
      track: 8,
      volleyball: 8,
    },
    5: {
      baseball: 9,
      basketball: 10,
      cricket: 9,
      dance: 9,
      football: 9,
      golf: 9,
      gymnastics: 9,
      hockey: 10,
      lacrosse: 9,
      rugby: 10,
      soccer: 10,
      swimming: 10,
      tennis: 10,
      track: 9,
      volleyball: 10,
    },
    6: {
      baseball: 8,
      basketball: 10,
      cricket: 9,
      dance: 8,
      football: 9,
      golf: 10,
      gymnastics: 10,
      hockey: 9,
      lacrosse: 10,
      rugby: 8,
      soccer: 8,
      swimming: 9,
      tennis: 10,
      track: 8,
      volleyball: 9,
    },
    7: {
      baseball: 7,
      basketball: 8,
      cricket: 7,
      dance: 7,
      football: 8,
      golf: 8,
      gymnastics: 7,
      hockey: 7,
      lacrosse: 7,
      rugby: 7,
      soccer: 7,
      swimming: 8,
      tennis: 7,
      track: 8,
      volleyball: 7,
    },
    8: {
      baseball: 6,
      basketball: 6,
      cricket: 6,
      dance: 6,
      football: 6,
      golf: 5,
      gymnastics: 6,
      hockey: 6,
      lacrosse: 6,
      rugby: 6,
      soccer: 6,
      swimming: 6,
      tennis: 6,
      track: 6,
      volleyball: 6,
    },
    9: {
      baseball: 7,
      basketball: 7,
      cricket: 8,
      dance: 8,
      football: 8,
      golf: 8,
      gymnastics: 8,
      hockey: 8,
      lacrosse: 7,
      rugby: 8,
      soccer: 7,
      swimming: 7,
      tennis: 7,
      track: 7,
      volleyball: 7,
    },
    10: {
      baseball: 8,
      basketball: 8,
      cricket: 8,
      dance: 8,
      football: 8,
      golf: 8,
      gymnastics: 8,
      hockey: 7,
      lacrosse: 8,
      rugby: 8,
      soccer: 8,
      swimming: 7,
      tennis: 8,
      track: 8,
      volleyball: 8,
    },
    11: {
      baseball: 8,
      basketball: 8,
      cricket: 8,
      dance: 8,
      football: 7,
      golf: 8,
      gymnastics: 9,
      hockey: 8,
      lacrosse: 8,
      rugby: 8,
      soccer: 7,
      swimming: 7,
      tennis: 7,
      track: 9,
      volleyball: 8,
    },
    12: {
      baseball: 8,
      basketball: 8,
      cricket: 8,
      dance: 8,
      football: 8,
      golf: 8,
      gymnastics: 8,
      hockey: 8,
      lacrosse: 8,
      rugby: 8,
      soccer: 8,
      swimming: 8,
      tennis: 8,
      track: 8,
      volleyball: 8,
    },
    13: {
      baseball: 6,
      basketball: 7,
      cricket: 7,
      dance: 7,
      football: 7,
      golf: 7,
      gymnastics: 7,
      hockey: 6,
      lacrosse: 7,
      rugby: 6,
      soccer: 7,
      swimming: 6,
      tennis: 7,
      track: 6,
      volleyball: 6,
    },
    14: {
      baseball: 7,
      basketball: 7,
      cricket: 7,
      dance: 7,
      football: 7,
      golf: 7,
      gymnastics: 7,
      hockey: 7,
      lacrosse: 7,
      rugby: 7,
      soccer: 8,
      swimming: 7,
      tennis: 7,
      track: 8,
      volleyball: 7,
    },
    15: {
      baseball: 7,
      basketball: 7,
      cricket: 7,
      dance: 7,
      football: 7,
      golf: 7,
      gymnastics: 7,
      hockey: 7,
      lacrosse: 7,
      rugby: 7,
      soccer: 7,
      swimming: 8,
      tennis: 7,
      track: 7,
      volleyball: 7,
    },
    16: {
      baseball: 8,
      basketball: 8,
      cricket: 8,
      dance: 8,
      football: 7,
      golf: 8,
      gymnastics: 8,
      hockey: 8,
      lacrosse: 9,
      rugby: 8,
      soccer: 7,
      swimming: 9,
      tennis: 8,
      track: 8,
      volleyball: 7,
    },
  },
  conclusions: {
    1: {
      baseball: 13,
      basketball: 14,
      cricket: 12,
      dance: 14,
      football: 13,
      golf: 14,
      gymnastics: 14,
      hockey: 13,
      lacrosse: 13,
      rugby: 14,
      soccer: 14,
      swimming: 13,
      tennis: 15,
      track: 13,
      volleyball: 15,
    },
    2: {
      baseball: 12,
      basketball: 13,
      cricket: 11,
      dance: 13,
      football: 12,
      golf: 13,
      gymnastics: 12,
      hockey: 12,
      lacrosse: 13,
      rugby: 14,
      soccer: 12,
      swimming: 12,
      tennis: 12,
      track: 11,
      volleyball: 14,
    },
    3: {
      baseball: 12,
      basketball: 12,
      cricket: 11,
      dance: 12,
      football: 10,
      golf: 12,
      gymnastics: 13,
      hockey: 11,
      lacrosse: 11,
      rugby: 11,
      soccer: 12,
      swimming: 12,
      tennis: 11,
      track: 11,
      volleyball: 11,
    },
    4: {
      baseball: 10,
      basketball: 11,
      cricket: 10,
      dance: 10,
      football: 9,
      golf: 9,
      gymnastics: 10,
      hockey: 9,
      lacrosse: 9,
      rugby: 8,
      soccer: 11,
      swimming: 11,
      tennis: 9,
      track: 9,
      volleyball: 9,
    },
    5: {
      baseball: 12,
      basketball: 12,
      cricket: 13,
      dance: 11,
      football: 12,
      golf: 12,
      gymnastics: 12,
      hockey: 12,
      lacrosse: 12,
      rugby: 12,
      soccer: 12,
      swimming: 11,
      tennis: 12,
      track: 12,
      volleyball: 12,
    },
    6: {
      baseball: 12,
      basketball: 13,
      cricket: 11,
      dance: 11,
      football: 11,
      golf: 13,
      gymnastics: 12,
      hockey: 12,
      lacrosse: 12,
      rugby: 12,
      soccer: 13,
      swimming: 13,
      tennis: 13,
      track: 13,
      volleyball: 12,
    },
    7: {
      baseball: 10,
      basketball: 9,
      cricket: 9,
      dance: 10,
      football: 10,
      golf: 10,
      gymnastics: 9,
      hockey: 9,
      lacrosse: 10,
      rugby: 10,
      soccer: 10,
      swimming: 9,
      tennis: 10,
      track: 10,
      volleyball: 9,
    },
    8: {
      baseball: 10,
      basketball: 11,
      cricket: 9,
      dance: 11,
      football: 10,
      golf: 11,
      gymnastics: 8,
      hockey: 10,
      lacrosse: 10,
      rugby: 11,
      soccer: 11,
      swimming: 11,
      tennis: 11,
      track: 11,
      volleyball: 11,
    },
    9: {
      baseball: 10,
      basketball: 10,
      cricket: 9,
      dance: 10,
      football: 9,
      golf: 10,
      gymnastics: 9,
      hockey: 10,
      lacrosse: 10,
      rugby: 9,
      soccer: 9,
      swimming: 11,
      tennis: 9,
      track: 10,
      volleyball: 10,
    },
    10: {
      baseball: 9,
      basketball: 10,
      cricket: 11,
      dance: 11,
      football: 10,
      golf: 11,
      gymnastics: 10,
      hockey: 9,
      lacrosse: 9,
      rugby: 10,
      soccer: 10,
      swimming: 11,
      tennis: 11,
      track: 10,
      volleyball: 11,
    },
    11: {
      baseball: 11,
      basketball: 10,
      cricket: 10,
      dance: 10,
      football: 11,
      golf: 11,
      gymnastics: 11,
      hockey: 10,
      lacrosse: 11,
      rugby: 11,
      soccer: 11,
      swimming: 11,
      tennis: 11,
      track: 11,
      volleyball: 10,
    },
    12: {
      baseball: 9,
      basketball: 11,
      cricket: 9,
      dance: 10,
      football: 11,
      golf: 11,
      gymnastics: 11,
      hockey: 10,
      lacrosse: 10,
      rugby: 10,
      soccer: 10,
      swimming: 10,
      tennis: 9,
      track: 10,
      volleyball: 10,
    },
    13: {
      baseball: 10,
      basketball: 10,
      cricket: 10,
      dance: 10,
      football: 10,
      golf: 10,
      gymnastics: 10,
      hockey: 10,
      lacrosse: 10,
      rugby: 10,
      soccer: 10,
      swimming: 10,
      tennis: 10,
      track: 10,
      volleyball: 10,
    },
    14: {
      baseball: 11,
      basketball: 11,
      cricket: 10,
      dance: 10,
      football: 10,
      golf: 9,
      gymnastics: 11,
      hockey: 9,
      lacrosse: 10,
      rugby: 11,
      soccer: 11,
      swimming: 9,
      tennis: 9,
      track: 10,
      volleyball: 10,
    },
    15: {
      baseball: 11,
      basketball: 9,
      cricket: 10,
      dance: 9,
      football: 11,
      golf: 11,
      gymnastics: 9,
      hockey: 9,
      lacrosse: 10,
      rugby: 9,
      soccer: 11,
      swimming: 11,
      tennis: 11,
      track: 11,
      volleyball: 10,
    },
    16: {
      baseball: 9,
      basketball: 9,
      cricket: 9,
      dance: 10,
      football: 10,
      golf: 9,
      gymnastics: 10,
      hockey: 10,
      lacrosse: 10,
      rugby: 10,
      soccer: 9,
      swimming: 9,
      tennis: 10,
      track: 10,
      volleyball: 10,
    },
  },
};

export const sessionsWithTiming = [
  {
    workoutId: 1,
    title: '⚡ Lightning Fast Feet',
    duration: '30 Min',
    exercises: [4, 7, 8, 9, 10],
    completion: {
      points: 63,
    },
    timing: {
      workoutIntro: 9,
      workoutConclusion: 14,
      totalExerciseIntroTime: 51,
      totalExerciseTime: 1699,
      totalWorkoutTime: 1773,
      totalMinutes: 30,
      exercises: [
        {
          exerciseId: 4,
          exerciseName: 'fastFeet',
          introTime: 9,
          exerciseTime: 272,
          combinedTime: 281,
        },
        {
          exerciseId: 7,
          exerciseName: 'highKnees',
          introTime: 10,
          exerciseTime: 341,
          combinedTime: 351,
        },
        {
          exerciseId: 8,
          exerciseName: 'oneLegStand',
          introTime: 12,
          exerciseTime: 353,
          combinedTime: 365,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 10,
          exerciseName: 'plank',
          introTime: 10,
          exerciseTime: 283,
          combinedTime: 293,
        },
      ],
    },
  },
  {
    workoutId: 2,
    title: '💃 Ball Dancing Fun',
    duration: '30 Min',
    exercises: [11, 12, 9, 13, 14],
    completion: {
      points: 22,
    },
    timing: {
      workoutIntro: 9,
      workoutConclusion: 12,
      totalExerciseIntroTime: 58,
      totalExerciseTime: 1709,
      totalWorkoutTime: 1788,
      totalMinutes: 30,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 12,
          exerciseName: 'burpees',
          introTime: 17,
          exerciseTime: 273,
          combinedTime: 290,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 13,
          exerciseName: 'skaterHops',
          introTime: 11,
          exerciseTime: 446,
          combinedTime: 457,
        },
        {
          exerciseId: 14,
          exerciseName: 'bearCrawl',
          introTime: 9,
          exerciseTime: 267,
          combinedTime: 276,
        },
      ],
    },
  },
  {
    workoutId: 3,
    title: '💪 Super Shot Power',
    duration: '35 Min',
    exercises: [15, 16, 9, 17, 18],
    completion: {
      points: 24,
    },
    timing: {
      workoutIntro: 8,
      workoutConclusion: 11,
      totalExerciseIntroTime: 51,
      totalExerciseTime: 2035,
      totalWorkoutTime: 2105,
      totalMinutes: 35,
      exercises: [
        {
          exerciseId: 15,
          exerciseName: 'mountainClimbers',
          introTime: 13,
          exerciseTime: 365,
          combinedTime: 378,
        },
        {
          exerciseId: 16,
          exerciseName: 'crabWalk',
          introTime: 10,
          exerciseTime: 296,
          combinedTime: 306,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 17,
          exerciseName: 'rabbitHops',
          introTime: 8,
          exerciseTime: 371,
          combinedTime: 379,
        },
        {
          exerciseId: 18,
          exerciseName: 'tigerPounces',
          introTime: 10,
          exerciseTime: 553,
          combinedTime: 563,
        },
      ],
    },
  },
  {
    workoutId: 4,
    title: '🦾 Upper Body Strength',
    duration: '30 Min',
    exercises: [23, 24, 26, 25, 27],
    completion: {
      points: 55,
    },
    timing: {
      workoutIntro: 8,
      workoutConclusion: 10,
      totalExerciseIntroTime: 58,
      totalExerciseTime: 1699,
      totalWorkoutTime: 1775,
      totalMinutes: 30,
      exercises: [
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 24,
          exerciseName: 'supermanHolds',
          introTime: 12,
          exerciseTime: 570,
          combinedTime: 582,
        },
        {
          exerciseId: 26,
          exerciseName: 'bridgeHolds',
          introTime: 12,
          exerciseTime: 280,
          combinedTime: 292,
        },
        {
          exerciseId: 25,
          exerciseName: 'wallSits',
          introTime: 13,
          exerciseTime: 416,
          combinedTime: 429,
        },
        {
          exerciseId: 27,
          exerciseName: 'shoulderTaps',
          introTime: 9,
          exerciseTime: 62,
          combinedTime: 71,
        },
      ],
    },
  },
  {
    workoutId: 5,
    title: '🦘 Bouncy Kangaroo Moves',
    duration: '31 Min',
    exercises: [22, 12, 8, 4, 11],
    completion: {
      points: 20,
    },
    timing: {
      workoutIntro: 9,
      workoutConclusion: 12,
      totalExerciseIntroTime: 57,
      totalExerciseTime: 1778,
      totalWorkoutTime: 1856,
      totalMinutes: 31,
      exercises: [
        {
          exerciseId: 22,
          exerciseName: 'upperCuts',
          introTime: 8,
          exerciseTime: 607,
          combinedTime: 615,
        },
        {
          exerciseId: 12,
          exerciseName: 'burpees',
          introTime: 17,
          exerciseTime: 273,
          combinedTime: 290,
        },
        {
          exerciseId: 8,
          exerciseName: 'oneLegStand',
          introTime: 12,
          exerciseTime: 353,
          combinedTime: 365,
        },
        {
          exerciseId: 4,
          exerciseName: 'fastFeet',
          introTime: 9,
          exerciseTime: 272,
          combinedTime: 281,
        },
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
      ],
    },
  },
  {
    workoutId: 6,
    title: '⭐ Superhero Training',
    duration: '25 Min',
    exercises: [23, 26, 27, 8, 17],
    completion: {
      points: 30,
    },
    timing: {
      workoutIntro: 9,
      workoutConclusion: 12,
      totalExerciseIntroTime: 53,
      totalExerciseTime: 1437,
      totalWorkoutTime: 1511,
      totalMinutes: 25,
      exercises: [
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 26,
          exerciseName: 'bridgeHolds',
          introTime: 12,
          exerciseTime: 280,
          combinedTime: 292,
        },
        {
          exerciseId: 27,
          exerciseName: 'shoulderTaps',
          introTime: 9,
          exerciseTime: 62,
          combinedTime: 71,
        },
        {
          exerciseId: 8,
          exerciseName: 'oneLegStand',
          introTime: 12,
          exerciseTime: 353,
          combinedTime: 365,
        },
        {
          exerciseId: 17,
          exerciseName: 'rabbitHops',
          introTime: 8,
          exerciseTime: 371,
          combinedTime: 379,
        },
      ],
    },
  },
  {
    workoutId: 7,
    title: '🛡️ Core Power Builder',
    duration: '29 Min',
    exercises: [23, 25, 27, 24, 11],
    completion: {
      points: 23,
    },
    timing: {
      workoutIntro: 7,
      workoutConclusion: 10,
      totalExerciseIntroTime: 57,
      totalExerciseTime: 1692,
      totalWorkoutTime: 1766,
      totalMinutes: 29,
      exercises: [
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 25,
          exerciseName: 'wallSits',
          introTime: 13,
          exerciseTime: 416,
          combinedTime: 429,
        },
        {
          exerciseId: 27,
          exerciseName: 'shoulderTaps',
          introTime: 9,
          exerciseTime: 62,
          combinedTime: 71,
        },
        {
          exerciseId: 24,
          exerciseName: 'supermanHolds',
          introTime: 12,
          exerciseTime: 570,
          combinedTime: 582,
        },
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
      ],
    },
  },
  {
    workoutId: 8,
    title: '🏃‍♀️ Endurance Runner',
    duration: '29 Min',
    exercises: [7, 4, 8, 26, 9],
    completion: {
      points: 26,
    },
    timing: {
      workoutIntro: 6,
      workoutConclusion: 10,
      totalExerciseIntroTime: 53,
      totalExerciseTime: 1696,
      totalWorkoutTime: 1765,
      totalMinutes: 29,
      exercises: [
        {
          exerciseId: 7,
          exerciseName: 'highKnees',
          introTime: 10,
          exerciseTime: 341,
          combinedTime: 351,
        },
        {
          exerciseId: 4,
          exerciseName: 'fastFeet',
          introTime: 9,
          exerciseTime: 272,
          combinedTime: 281,
        },
        {
          exerciseId: 8,
          exerciseName: 'oneLegStand',
          introTime: 12,
          exerciseTime: 353,
          combinedTime: 365,
        },
        {
          exerciseId: 26,
          exerciseName: 'bridgeHolds',
          introTime: 12,
          exerciseTime: 280,
          combinedTime: 292,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
      ],
    },
  },
  {
    workoutId: 9,
    title: '🐻 Animal Moves',
    duration: '44 Min',
    exercises: [19, 20, 18, 21, 22],
    completion: {
      points: 21,
    },
    timing: {
      workoutIntro: 7,
      workoutConclusion: 10,
      totalExerciseIntroTime: 51,
      totalExerciseTime: 2569,
      totalWorkoutTime: 2637,
      totalMinutes: 44,
      exercises: [
        {
          exerciseId: 19,
          exerciseName: 'zebraGallops',
          introTime: 11,
          exerciseTime: 513,
          combinedTime: 524,
        },
        {
          exerciseId: 20,
          exerciseName: 'rainbowReaches',
          introTime: 14,
          exerciseTime: 366,
          combinedTime: 380,
        },
        {
          exerciseId: 18,
          exerciseName: 'tigerPounces',
          introTime: 10,
          exerciseTime: 553,
          combinedTime: 563,
        },
        {
          exerciseId: 21,
          exerciseName: 'tricepDips',
          introTime: 8,
          exerciseTime: 530,
          combinedTime: 538,
        },
        {
          exerciseId: 22,
          exerciseName: 'upperCuts',
          introTime: 8,
          exerciseTime: 607,
          combinedTime: 615,
        },
      ],
    },
  },
  {
    workoutId: 10,
    title: '🌟 Balance Master',
    duration: '31 Min',
    exercises: [11, 13, 14, 23, 25],
    completion: {
      points: 19,
    },
    timing: {
      workoutIntro: 8,
      workoutConclusion: 10,
      totalExerciseIntroTime: 56,
      totalExerciseTime: 1773,
      totalWorkoutTime: 1847,
      totalMinutes: 31,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 13,
          exerciseName: 'skaterHops',
          introTime: 11,
          exerciseTime: 446,
          combinedTime: 457,
        },
        {
          exerciseId: 14,
          exerciseName: 'bearCrawl',
          introTime: 9,
          exerciseTime: 267,
          combinedTime: 276,
        },
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 25,
          exerciseName: 'wallSits',
          introTime: 13,
          exerciseTime: 416,
          combinedTime: 429,
        },
      ],
    },
  },
  {
    workoutId: 11,
    title: '🚀 Explosive Power',
    duration: '39 Min',
    exercises: [15, 9, 17, 18, 21],
    completion: {
      points: 27,
    },
    timing: {
      workoutIntro: 8,
      workoutConclusion: 11,
      totalExerciseIntroTime: 49,
      totalExerciseTime: 2269,
      totalWorkoutTime: 2337,
      totalMinutes: 39,
      exercises: [
        {
          exerciseId: 15,
          exerciseName: 'mountainClimbers',
          introTime: 13,
          exerciseTime: 365,
          combinedTime: 378,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 17,
          exerciseName: 'rabbitHops',
          introTime: 8,
          exerciseTime: 371,
          combinedTime: 379,
        },
        {
          exerciseId: 18,
          exerciseName: 'tigerPounces',
          introTime: 10,
          exerciseTime: 553,
          combinedTime: 563,
        },
        {
          exerciseId: 21,
          exerciseName: 'tricepDips',
          introTime: 8,
          exerciseTime: 530,
          combinedTime: 538,
        },
      ],
    },
  },
  {
    workoutId: 12,
    title: '🎯 Precision Training',
    duration: '22 Min',
    exercises: [11, 12, 23, 26, 27],
    completion: {
      points: 25,
    },
    timing: {
      workoutIntro: 8,
      workoutConclusion: 10,
      totalExerciseIntroTime: 61,
      totalExerciseTime: 1259,
      totalWorkoutTime: 1338,
      totalMinutes: 22,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 12,
          exerciseName: 'burpees',
          introTime: 17,
          exerciseTime: 273,
          combinedTime: 290,
        },
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 26,
          exerciseName: 'bridgeHolds',
          introTime: 12,
          exerciseTime: 280,
          combinedTime: 292,
        },
        {
          exerciseId: 27,
          exerciseName: 'shoulderTaps',
          introTime: 9,
          exerciseTime: 62,
          combinedTime: 71,
        },
      ],
    },
  },
  {
    workoutId: 13,
    title: '🔥 Fire Starter',
    duration: '29 Min',
    exercises: [4, 7, 8, 9, 10],
    completion: {
      points: 20,
    },
    timing: {
      workoutIntro: 7,
      workoutConclusion: 10,
      totalExerciseIntroTime: 51,
      totalExerciseTime: 1699,
      totalWorkoutTime: 1767,
      totalMinutes: 29,
      exercises: [
        {
          exerciseId: 4,
          exerciseName: 'fastFeet',
          introTime: 9,
          exerciseTime: 272,
          combinedTime: 281,
        },
        {
          exerciseId: 7,
          exerciseName: 'highKnees',
          introTime: 10,
          exerciseTime: 341,
          combinedTime: 351,
        },
        {
          exerciseId: 8,
          exerciseName: 'oneLegStand',
          introTime: 12,
          exerciseTime: 353,
          combinedTime: 365,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 10,
          exerciseName: 'plank',
          introTime: 10,
          exerciseTime: 283,
          combinedTime: 293,
        },
      ],
    },
  },
  {
    workoutId: 14,
    title: '💫 Flexibility Fun',
    duration: '31 Min',
    exercises: [11, 13, 14, 23, 25],
    completion: {
      points: 18,
    },
    timing: {
      workoutIntro: 7,
      workoutConclusion: 10,
      totalExerciseIntroTime: 56,
      totalExerciseTime: 1773,
      totalWorkoutTime: 1846,
      totalMinutes: 31,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 13,
          exerciseName: 'skaterHops',
          introTime: 11,
          exerciseTime: 446,
          combinedTime: 457,
        },
        {
          exerciseId: 14,
          exerciseName: 'bearCrawl',
          introTime: 9,
          exerciseTime: 267,
          combinedTime: 276,
        },
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 25,
          exerciseName: 'wallSits',
          introTime: 13,
          exerciseTime: 416,
          combinedTime: 429,
        },
      ],
    },
  },
  {
    workoutId: 15,
    title: '⚔️ Warrior Training',
    duration: '29 Min',
    exercises: [23, 24, 26, 27, 17],
    completion: {
      points: 35,
    },
    timing: {
      workoutIntro: 7,
      workoutConclusion: 10,
      totalExerciseIntroTime: 53,
      totalExerciseTime: 1654,
      totalWorkoutTime: 1724,
      totalMinutes: 29,
      exercises: [
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 24,
          exerciseName: 'supermanHolds',
          introTime: 12,
          exerciseTime: 570,
          combinedTime: 582,
        },
        {
          exerciseId: 26,
          exerciseName: 'bridgeHolds',
          introTime: 12,
          exerciseTime: 280,
          combinedTime: 292,
        },
        {
          exerciseId: 27,
          exerciseName: 'shoulderTaps',
          introTime: 9,
          exerciseTime: 62,
          combinedTime: 71,
        },
        {
          exerciseId: 17,
          exerciseName: 'rabbitHops',
          introTime: 8,
          exerciseTime: 371,
          combinedTime: 379,
        },
      ],
    },
  },
  {
    workoutId: 16,
    title: '🎪 Circus Star',
    duration: '35 Min',
    exercises: [11, 12, 15, 18, 21],
    completion: {
      points: 22,
    },
    timing: {
      workoutIntro: 8,
      workoutConclusion: 10,
      totalExerciseIntroTime: 59,
      totalExerciseTime: 1994,
      totalWorkoutTime: 2071,
      totalMinutes: 35,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 12,
          exerciseName: 'burpees',
          introTime: 17,
          exerciseTime: 273,
          combinedTime: 290,
        },
        {
          exerciseId: 15,
          exerciseName: 'mountainClimbers',
          introTime: 13,
          exerciseTime: 365,
          combinedTime: 378,
        },
        {
          exerciseId: 18,
          exerciseName: 'tigerPounces',
          introTime: 10,
          exerciseTime: 553,
          combinedTime: 563,
        },
        {
          exerciseId: 21,
          exerciseName: 'tricepDips',
          introTime: 8,
          exerciseTime: 530,
          combinedTime: 538,
        },
      ],
    },
  },
  {
    workoutId: 17,
    title: '🔥 Elite Power Training',
    duration: '0 Min',
    exercises: [35, 36, 40, 41, 42],
    completion: {
      points: 45,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 0,
      totalExerciseTime: 0,
      totalWorkoutTime: 0,
      totalMinutes: 0,
      exercises: [],
    },
  },
  {
    workoutId: 18,
    title: '🏃‍♂️ Athletic Beast Mode',
    duration: '0 Min',
    exercises: [39, 37, 34, 46, 38],
    completion: {
      points: 52,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 0,
      totalExerciseTime: 0,
      totalWorkoutTime: 0,
      totalMinutes: 0,
      exercises: [],
    },
  },
  {
    workoutId: 19,
    title: '⭐ Pro Athlete Prep',
    duration: '0 Min',
    exercises: [43, 45, 35, 40, 39],
    completion: {
      points: 48,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 0,
      totalExerciseTime: 0,
      totalWorkoutTime: 0,
      totalMinutes: 0,
      exercises: [],
    },
  },
  {
    workoutId: 20,
    title: "🏆 Champion's Challenge",
    duration: '0 Min',
    exercises: [46, 37, 41, 42, 44],
    completion: {
      points: 55,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 0,
      totalExerciseTime: 0,
      totalWorkoutTime: 0,
      totalMinutes: 0,
      exercises: [],
    },
  },
  {
    workoutId: 21,
    title: '💪 Strength Builder Plus',
    duration: '22 Min',
    exercises: [24, 26, 27, 28, 30],
    completion: {
      points: 38,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 43,
      totalExerciseTime: 1294,
      totalWorkoutTime: 1337,
      totalMinutes: 22,
      exercises: [
        {
          exerciseId: 24,
          exerciseName: 'supermanHolds',
          introTime: 12,
          exerciseTime: 570,
          combinedTime: 582,
        },
        {
          exerciseId: 26,
          exerciseName: 'bridgeHolds',
          introTime: 12,
          exerciseTime: 280,
          combinedTime: 292,
        },
        {
          exerciseId: 27,
          exerciseName: 'shoulderTaps',
          introTime: 9,
          exerciseTime: 62,
          combinedTime: 71,
        },
        {
          exerciseId: 28,
          exerciseName: 'inchwormWalk',
          introTime: 10,
          exerciseTime: 382,
          combinedTime: 392,
        },
      ],
    },
  },
  {
    workoutId: 22,
    title: '🏃‍♀️ Cardio Crusher',
    duration: '31 Min',
    exercises: [4, 8, 10, 15, 21],
    completion: {
      points: 35,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 52,
      totalExerciseTime: 1803,
      totalWorkoutTime: 1855,
      totalMinutes: 31,
      exercises: [
        {
          exerciseId: 4,
          exerciseName: 'fastFeet',
          introTime: 9,
          exerciseTime: 272,
          combinedTime: 281,
        },
        {
          exerciseId: 8,
          exerciseName: 'oneLegStand',
          introTime: 12,
          exerciseTime: 353,
          combinedTime: 365,
        },
        {
          exerciseId: 10,
          exerciseName: 'plank',
          introTime: 10,
          exerciseTime: 283,
          combinedTime: 293,
        },
        {
          exerciseId: 15,
          exerciseName: 'mountainClimbers',
          introTime: 13,
          exerciseTime: 365,
          combinedTime: 378,
        },
        {
          exerciseId: 21,
          exerciseName: 'tricepDips',
          introTime: 8,
          exerciseTime: 530,
          combinedTime: 538,
        },
      ],
    },
  },
  {
    workoutId: 23,
    title: '⚖️ Balance & Coordination',
    duration: '25 Min',
    exercises: [11, 12, 19, 20, 31],
    completion: {
      points: 32,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 53,
      totalExerciseTime: 1425,
      totalWorkoutTime: 1478,
      totalMinutes: 25,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 12,
          exerciseName: 'burpees',
          introTime: 17,
          exerciseTime: 273,
          combinedTime: 290,
        },
        {
          exerciseId: 19,
          exerciseName: 'zebraGallops',
          introTime: 11,
          exerciseTime: 513,
          combinedTime: 524,
        },
        {
          exerciseId: 20,
          exerciseName: 'rainbowReaches',
          introTime: 14,
          exerciseTime: 366,
          combinedTime: 380,
        },
      ],
    },
  },
  {
    workoutId: 24,
    title: '🦾 Full Body Power',
    duration: '29 Min',
    exercises: [23, 25, 17, 18, 29],
    completion: {
      points: 40,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 43,
      totalExerciseTime: 1711,
      totalWorkoutTime: 1754,
      totalMinutes: 29,
      exercises: [
        {
          exerciseId: 23,
          exerciseName: 'pushUps',
          introTime: 12,
          exerciseTime: 371,
          combinedTime: 383,
        },
        {
          exerciseId: 25,
          exerciseName: 'wallSits',
          introTime: 13,
          exerciseTime: 416,
          combinedTime: 429,
        },
        {
          exerciseId: 17,
          exerciseName: 'rabbitHops',
          introTime: 8,
          exerciseTime: 371,
          combinedTime: 379,
        },
        {
          exerciseId: 18,
          exerciseName: 'tigerPounces',
          introTime: 10,
          exerciseTime: 553,
          combinedTime: 563,
        },
      ],
    },
  },
  {
    workoutId: 25,
    title: '🏃‍♂️ Fitness Foundations',
    duration: '26 Min',
    exercises: [7, 9, 13, 16, 32],
    completion: {
      points: 18,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 41,
      totalExerciseTime: 1533,
      totalWorkoutTime: 1574,
      totalMinutes: 26,
      exercises: [
        {
          exerciseId: 7,
          exerciseName: 'highKnees',
          introTime: 10,
          exerciseTime: 341,
          combinedTime: 351,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 13,
          exerciseName: 'skaterHops',
          introTime: 11,
          exerciseTime: 446,
          combinedTime: 457,
        },
        {
          exerciseId: 16,
          exerciseName: 'crabWalk',
          introTime: 10,
          exerciseTime: 296,
          combinedTime: 306,
        },
      ],
    },
  },
  {
    workoutId: 26,
    title: '🔆 Active Start',
    duration: '25 Min',
    exercises: [22, 14, 11, 33, 7],
    completion: {
      points: 15,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 38,
      totalExerciseTime: 1488,
      totalWorkoutTime: 1526,
      totalMinutes: 25,
      exercises: [
        {
          exerciseId: 22,
          exerciseName: 'upperCuts',
          introTime: 8,
          exerciseTime: 607,
          combinedTime: 615,
        },
        {
          exerciseId: 14,
          exerciseName: 'bearCrawl',
          introTime: 9,
          exerciseTime: 267,
          combinedTime: 276,
        },
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 7,
          exerciseName: 'highKnees',
          introTime: 10,
          exerciseTime: 341,
          combinedTime: 351,
        },
      ],
    },
  },
  {
    workoutId: 27,
    title: '💪 Strength Basics',
    duration: '22 Min',
    exercises: [16, 13, 32, 11, 14],
    completion: {
      points: 16,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 41,
      totalExerciseTime: 1282,
      totalWorkoutTime: 1323,
      totalMinutes: 22,
      exercises: [
        {
          exerciseId: 16,
          exerciseName: 'crabWalk',
          introTime: 10,
          exerciseTime: 296,
          combinedTime: 306,
        },
        {
          exerciseId: 13,
          exerciseName: 'skaterHops',
          introTime: 11,
          exerciseTime: 446,
          combinedTime: 457,
        },
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 14,
          exerciseName: 'bearCrawl',
          introTime: 9,
          exerciseTime: 267,
          combinedTime: 276,
        },
      ],
    },
  },
  {
    workoutId: 28,
    title: '🌟 Coordination Fun',
    duration: '35 Min',
    exercises: [11, 14, 22, 9, 13],
    completion: {
      points: 14,
    },
    timing: {
      workoutIntro: 0,
      workoutConclusion: 0,
      totalExerciseIntroTime: 49,
      totalExerciseTime: 2043,
      totalWorkoutTime: 2092,
      totalMinutes: 35,
      exercises: [
        {
          exerciseId: 11,
          exerciseName: 'frogJumps',
          introTime: 11,
          exerciseTime: 273,
          combinedTime: 284,
        },
        {
          exerciseId: 14,
          exerciseName: 'bearCrawl',
          introTime: 9,
          exerciseTime: 267,
          combinedTime: 276,
        },
        {
          exerciseId: 22,
          exerciseName: 'upperCuts',
          introTime: 8,
          exerciseTime: 607,
          combinedTime: 615,
        },
        {
          exerciseId: 9,
          exerciseName: 'sideLunges',
          introTime: 10,
          exerciseTime: 450,
          combinedTime: 460,
        },
        {
          exerciseId: 13,
          exerciseName: 'skaterHops',
          introTime: 11,
          exerciseTime: 446,
          combinedTime: 457,
        },
      ],
    },
  },
];

// Helper function to get exercise timing by name
export const getExerciseTiming = (exerciseName) => {
  return {
    introTime: exerciseTiming.intros[exerciseName] || 0,
    exerciseTime: exerciseTiming.main[exerciseName] || 0,
    combinedTime:
      (exerciseTiming.intros[exerciseName] || 0) +
      (exerciseTiming.main[exerciseName] || 0),
  };
};

// Helper function to get session timing by workout ID
export const getSessionTiming = (workoutId) => {
  return sessionsWithTiming.find((session) => session.workoutId === workoutId)
    ?.timing;
};
